<template>
  <div
    class="fl-reg-log-wrapper"
    :class="{ 'fl-reg-log-wrapper--registering': allChecksPassed }"
  >
    <div>
      <div
        v-if="!userAuthenticated"
        class="fl-reg-cta"
      >
        <fn-headline
          type="h2"
          size="h3"
          color="black"
        >
          {{ $t('forms.register.newUser') }}
        </fn-headline>
        <fn-button
          v-show="!isRegistering"
          full-width
          secondary
          @click="onRegisterBtnClick"
        >
          {{ $t('forms.register.title') }}
        </fn-button>
        <hr
          v-if="!isRegistering"
          class="fl-reg-log-hr"
        />
      </div>
      <fn-vuex-form-login
        v-show="!isRegistering && !userAuthenticated"
        ref="loginForm"
        class="fl-log-form"
        friends-light
        full-width-inputs
        :redirect-enabled="false"
        :email="softLoginEmail"
        @submit="checkNewsletterStatus"
      />
      <fn-vuex-form-friends-light-discount v-show="!isRegistering && userAuthenticated && !friendsLightQrCode" />
      <fn-vuex-form-register
        v-show="isRegistering && !userAuthenticated"
        ref="registrationForm"
        friends-light
        redirect-disabled
        full-width-inputs
        @registration-success="registrationSuccess"
      />
      <div
        v-if="isRegistering && !allChecksPassed"
        class="fl-log-cta"
      >
        <hr class="fl-reg-log-hr" />
        <fn-headline
          type="h2"
          size="h3"
          color="black"
        >
          {{ $t('forms.login.headings.alreadyRegistered') }}
        </fn-headline>
        <fn-button
          full-width
          quaternary-alt
          @click="onLoginBtnClick"
        >
          {{ $t('forms.login.title') }}
        </fn-button>
      </div>
    </div>
  </div>
</template>

<script>
import { OCC_USER_ID_ANONYMOUS, OCC_USER_ID_CURRENT, OCC_USER_ID_GUEST } from '@/utils/occ-constants';
import newsletter from '@/mixins/Newsletter';

export default defineComponent({
  mixins: [newsletter],
  data: () => ({
    isRegistering: false,
  }),
  computed: {
    ...mapState(useUserStore, {
      uid: 'uid',
      friendsLightQrCode: 'getFriendsLightQrCode',
      isAuthenticated: 'getIsAuthenticated',
      termsOfServiceAccepted: 'getTermsOfServiceAccepted',
      isSoftLoggedIn: 'softLogin',
    }),
    ...mapWritableState(useNewsletterStore, {
      hasNewsletterSubscription: 'hasNewsletterSubscription',
    }),
    userAuthenticated() {
      return this.isAuthenticated && this.uid !== OCC_USER_ID_ANONYMOUS;
    },
    allChecksPassed() {
      return this.termsOfServiceAccepted && this.hasNewsletterSubscription && !this.friendsLightQrCode;
    },
    userHasEmail() {
      return (
        this.uid &&
        this.uid !== OCC_USER_ID_ANONYMOUS &&
        this.uid !== OCC_USER_ID_CURRENT &&
        this.uid !== OCC_USER_ID_GUEST
      );
    },
    softLoginEmail() {
      if (!this.isSoftLoggedIn) {
        return null;
      }
      if (this.userHasEmail) {
        return this.uid;
      }
      return useCookie('uid').value;
    },
  },
  async beforeMount() {
    await this.checkNewsletterStatus();
  },
  methods: {
    onRegisterBtnClick() {
      this.isRegistering = true;
    },
    onLoginBtnClick() {
      this.isRegistering = false;
    },
    registrationSuccess() {
      if (!this.hasNewsletterSubscription) {
        this.hasNewsletterSubscription = true;
      }
      this.isRegistering = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.fl-reg-log-wrapper {
  background-color: white;
  border-radius: map-get($border-radiuses, 'xxl');
  box-shadow: map-get($box-shadows, 'friends-light');
  margin: 0 auto;
  max-width: calc(100% - #{$pad * 2});
  padding: $space;
  width: 100%;
  z-index: 3;

  &--registering {
    visibility: hidden;
  }

  @include bp(m) {
    max-width: 542px;
  }

  .fl-reg-cta,
  .fl-log-cta {
    text-align: center;
  }

  .fl-reg-log-hr {
    margin: $pad * 2 0;
  }
}
</style>
